import "./Controller.css"
import React, { useContext, useEffect, useState } from 'react'
import { Container } from './styled'
import ParameterScale from "./Scale/ParameterScale";
import { KEYS, PARAMTER_TITLES } from "../../../../constants/constants";
import { useModal } from "../../../../hooks/useModal";
import { Popup } from "../../../Popup/Popup";
import DetailsPopup from "./DetailsPopup";
import { Data, DataKey } from "../../../../interface/Data";
import { SliderGradient } from "../../../../interface/Slider";
import { Values } from "../../../../interface/Values";
import { GameContext } from "../../../../contexts/GameContext";
import { Box, Button, Checkbox, Typography, Grid } from "@mui/material";
import { InfoCard } from "../Card/InfoCard";
import ArrowIcon from "./ArrowIcon";

interface Props {
  availablePoints: number;
  changeAvailablePoints: React.Dispatch<React.SetStateAction<number>>
  values: Values;
  data: Data;
  targetData: Data;
  setTargetData: React.Dispatch<React.SetStateAction<Data>>;
}

const Controller = ({ data, targetData, setTargetData, values, availablePoints, changeAvailablePoints }: Props) => {
  const { bounds, scales, interfaceParams } = useContext(GameContext);

  const { isShown: showPopup, toggle: togglePopup } = useModal();
  const [selectedParam, setSelectedParam] = useState<"temp" | "window" | "curtains" | "mecanical_ventilation" | "artificial_light" | "electric_equipement" |
    "dressing" | "cost" | "ges" | "air_quality" | "visual_comfort" | "thermal_comfort" | "chauffage" | "climatisation" | "electricity">("temp");

  const [isActive, setActive] = useState<string[]>([])

  const [currentSelected, setSelected] = useState<number>(0)

  useEffect(() => {
    const lines = document.getElementsByClassName("lines");
    for (let i = 0; i < lines.length; ++i) {
      const children = lines[i].children;
      for (let i = 0; i < children.length; ++i) {
        const el = children[i] as HTMLElement;
        el.style.setProperty("opacity", "0.2");
        el.style.setProperty("stroke-width", "2px");
      }
    }

    const rects = document.getElementsByClassName("rect-container");
    for (let i = 0; i < rects.length; ++i) {
      const el = rects[i] as HTMLElement;
      el.style.setProperty("opacity", "1");
      el.style.setProperty("stroke-width", "2px");
    }
    console.log("target", targetData)
  }, [])

  /**
   * Functions that returns -1 if new value is further than current data or +1
   * if new value is closer to current data.
   * @param attribute 
   * @param newAttributeValue 
   * @returns -1 or 1
   */
  function computePointsDiff(attribute: DataKey, newAttributeValue: number) {
    const oldDiff = Math.abs(targetData[attribute] - data[attribute]);
    const newDiff = Math.abs(newAttributeValue - data[attribute]);
    return newDiff > oldDiff ? -1 : 1;
  }

  const updateData = (attribute: DataKey, newValue: number) => {
    // Check if target value is still within domain.
    const greaterThanMin = parseFloat((targetData[attribute] + newValue).toFixed(2)) >= bounds[attribute]["min"];
    const lesserThanMax = parseFloat((targetData[attribute] + newValue).toFixed(2)) <= bounds[attribute]["max"];
    if (greaterThanMin && lesserThanMax) {
      // Check if you still have points to allocate.
      if (availablePoints > 0) {
        // Updates available points.
        changeAvailablePoints(availablePoints + computePointsDiff(attribute, targetData[attribute] + newValue));
        // Updates targetData.
        setTargetData(prev => ({ ...prev, [attribute]: prev[attribute] + newValue }));
      }
      // Check if change increases available points.
      else {
        const newAttributeValue = targetData[attribute] + newValue;
        if (computePointsDiff(attribute, newAttributeValue) > 0) {
          // Updates targetData.
          setTargetData(prev => ({ ...prev, [attribute]: prev[attribute] + newValue }));
          // Updates available points.
          changeAvailablePoints(availablePoints + computePointsDiff(attribute, newAttributeValue));
        }
      }
    }
  }

  const onHoverQuality = (ids: string[], rectIds: string[] = [], entering = true) => {
    ids.forEach((id) => {
      const el = document.getElementById(id)

      if (el) {
        el.style.setProperty("opacity", entering ? "1" : "0.2");
        el.style.setProperty("stroke-width", entering ? "4px" : "2px");
      }

    });

    rectIds.forEach((rectId) => {
      const el = document.getElementById(rectId);
      const rect = el?.getElementsByClassName("rect-container")[0];
      const rectEl = rect as HTMLElement;
      rectEl?.style.setProperty("stroke-width", entering ? "4px" : "2px");
    });
  }

  function onComponentClick(keyId: "temp" | "window" | "curtains" | "mecanical_ventilation" | "artificial_light" | "electric_equipement" |
    "dressing" | "cost" | "ges" | "air_quality" | "visual_comfort" | "thermal_comfort" | "chauffage" | "climatisation" | "electricity") {
    setSelectedParam(keyId);
    togglePopup();
  }

  function processTextSpans(keyId: "temp" | "window" | "curtains" | "mecanical_ventilation" | "artificial_light" | "electric_equipement" |
    "dressing" | "cost" | "ges" | "air_quality" | "visual_comfort" | "thermal_comfort" | "chauffage" | "climatisation" | "electricity") {
    if (interfaceParams) {
      const arr = []
      const lines = interfaceParams["bars"][keyId]["title"]
      for (let i = 0; i < lines.length; ++i) {
        arr.push(getTSpan(lines[i], 0, i * 15, `tspan-${keyId}-${i}`))
      }

      return arr
    }

    return <g></g>
  }

  function getTSpan(text: string, x: number, dy: number, key: string) {
    return <tspan key={key} x={x} dy={dy}>{text}</tspan>;
  }


  return (
    <Box className="control" sx={{display:"block"}} >
      <Grid className="clim-controler">
        <Box>
          <Typography className="font-list">Climatisation</Typography>
          <Typography className="font-list txt">Permet d’atteindre la température de consigne</Typography>
        </Box>
        <Box>
          <Checkbox sx={{'& .MuiSvgIcon-root':{display:"block !important"}}} checked={targetData.clim_on_off==1} onClick={()=>{setTargetData(prev => ({ ...prev, clim_on_off:Number(!prev.clim_on_off) }));console.log(targetData)}}/>
        </Box>
      </Grid>
      <Box sx={{display:"block"}}>
        <Box className="controler" sx={{display:"flex"}}>
          <Button className="slide-button" onClick={()=>{ setSelected((((currentSelected-1) % 7) + 7) % 7)}}><ArrowIcon/></Button>
          <InfoCard isSelected={currentSelected==0} updateActive={(state)=>{state?setActive(["chauffage","climatisation","thermal_comfort"]):setActive([])}} isActive={isActive} name="temp" toggleInfo={() => { onComponentClick("temp"); }} min={bounds["temp"]["min"]} minUnite="Froid" max={bounds["temp"]["max"]} maxUnite="Chaud" unite=" °C" step={scales.temp} defaultValue={targetData.temp} title="Température de consigne" updatedValue={(direction)=>{updateData("temp", direction)}}/>
          <InfoCard isSelected={currentSelected==1} updateActive={(state)=>{state?setActive(["chauffage","climatisation","thermal_comfort","air_quality"]):setActive([])}} isActive={isActive} name="window" toggleInfo={() => { onComponentClick("window"); }} min={bounds["window"]["min"]} minUnite="Fermées" max={bounds["window"]["max"]} maxUnite="Ouvertes" title="Nombre de fenêtres ouvertes" step={scales.window} defaultValue={targetData.window} updatedValue={(direction)=>{updateData("window", direction)}} />
          <InfoCard isSelected={currentSelected==2} updateActive={(state)=>{state?setActive(["chauffage","climatisation","thermal_comfort","visual_comfort"]):setActive([])}} isActive={isActive} name="curtains" toggleInfo={() => { onComponentClick("curtains"); }} min={bounds["curtains"]["min"]} minUnite="Fermés" max={bounds["curtains"]["max"]} maxUnite="Ouverts" unite=" %" title="Ouverture des rideaux" step={scales.curtains} defaultValue={targetData.curtains} updatedValue={(direction)=>{updateData("curtains", direction)}} />
          <InfoCard isSelected={currentSelected==3} updateActive={(state)=>{state?setActive(["electricity","air_quality"]):setActive([])}} isActive={isActive} name="mecanical_ventilation" toggleInfo={() => { onComponentClick("mecanical_ventilation"); }} min={bounds["mecanical_ventilation"]["min"]} minUnite="Faible" max={bounds["mecanical_ventilation"]["max"]} maxUnite="Élevée" unite=" %" title="Ventilation mécanique" step={scales.mecanical_ventilation} defaultValue={targetData.mecanical_ventilation} updatedValue={(direction)=>{updateData("mecanical_ventilation", direction)}} />
          <InfoCard isSelected={currentSelected==4} updateActive={(state)=>{state?setActive(["electricity","visual_comfort", "thermal_comfort", "chauffage","climatisation"]):setActive([])}} isActive={isActive} name="artificial_light" toggleInfo={() => { onComponentClick("artificial_light"); }} min={bounds["artificial_light"]["min"]} minUnite="Faible" max={bounds["artificial_light"]["max"]} maxUnite="Élevé" unite=" %" title="Éclairage artificiel" step={scales.artificial_light} defaultValue={targetData.artificial_light} updatedValue={(direction)=>{updateData("artificial_light", direction)}} />
          <InfoCard isSelected={currentSelected==5} updateActive={(state)=>{state?setActive(["thermal_comfort"]):setActive([])}} isActive={isActive} name="dressing" toggleInfo={() => { onComponentClick("dressing"); }} min={bounds["dressing"]["min"]} minUnite="Nu" max={bounds["dressing"]["max"]} maxUnite="Chaudement" unite=" clo" needPrecision={true} title="Habillement" step={scales.dressing} defaultValue={targetData.dressing} updatedValue={(direction)=>{updateData("dressing", direction)}} />
          <InfoCard isSelected={currentSelected==6} updateActive={(state)=>{state?setActive(["electricity", "thermal_comfort", "chauffage","climatisation"]):setActive([])}} isActive={isActive} name="electric_equipement" toggleInfo={() => { onComponentClick("electric_equipement"); }} min={bounds["electric_equipement"]["min"]} max={bounds["electric_equipement"]["max"]} unite=" W" showStepBtn={false}  title="Appareils électriques" step={scales.electric_equipement} defaultValue={values.app_elect??0} updatedValue={(direction)=>{updateData("electric_equipement", direction)}} />
          <Button className="slide-button" sx={{transform:"rotateY(180deg);"}} onClick={()=>{ setSelected((currentSelected+1)%7)}}><ArrowIcon /></Button>
        </Box>

        <Box className="control-result" sx={{display:"flex"}}>
          <InfoCard isSelected={currentSelected<=2 || currentSelected==4 || currentSelected==6} updateActive={(state)=>{state?setActive(["temp","window","curtains","electric_equipement","artificial_light"]):setActive([])}} isActive={isActive} name="chauffage" toggleInfo={() => { onComponentClick("chauffage"); }} min={bounds["chauffage"]["min"]} minUnite="Faible" max={bounds["chauffage"]["max"]} maxUnite="Élevé" unite=" W" showStepBtn={false} title="Chauffage" defaultValue={values.chauffage} type="info" />
          <InfoCard isSelected={currentSelected<=2 || currentSelected==4 || currentSelected==6} updateActive={(state)=>{state?setActive(["temp","window","curtains","electric_equipement","artificial_light"]):setActive([])}} isActive={isActive} name="climatisation" toggleInfo={() => { onComponentClick("climatisation"); }} min={bounds["climatisation"]["min"]} minUnite="Faible" max={bounds["climatisation"]["max"]} maxUnite="Élevée" unite=" W" showStepBtn={false} title="Climatisation" defaultValue={values.climatisation} type="info" />
          <InfoCard isSelected={currentSelected==3 || currentSelected==4 || currentSelected==6}  updateActive={(state)=>{state?setActive(["mecanical_ventilation","electric_equipement","artificial_light"]):setActive([])}} isActive={isActive} name="electricity" toggleInfo={() => { onComponentClick("electricity"); }} min={bounds["electricity"]["min"]} minUnite="Faible" max={bounds["electricity"]["max"]} maxUnite="Élevée" unite=" W" showStepBtn={false} title="Électricité" defaultValue={values.electricity} type="info" />
          <InfoCard isSelected={currentSelected==1 || currentSelected==3} updateActive={(state)=>{state?setActive(["mecanical_ventilation","window"]):setActive([])}} isActive={isActive} name="air_quality" toggleInfo={() => { onComponentClick("air_quality"); }} min={bounds["air_quality"]["min"]} minUnite="Bonne" max={bounds["air_quality"]["max"]} maxUnite="Mauvaise" unite=" ppm CO₂" showStepBtn={false} title="Qualité de l’air" defaultValue={values.air_quality} type="info" />
          <InfoCard isSelected={currentSelected==2 || currentSelected==4} updateActive={(state)=>{state?setActive(["curtains","artificial_light"]):setActive([])}} isActive={isActive} name="visual_comfort" toggleInfo={() => { onComponentClick("visual_comfort"); }} min={bounds["visual_comfort"]["min"]} minUnite="Sombre" max={bounds["visual_comfort"]["max"]} maxUnite="Éblouissant" unite=" lux" showStepBtn={false} title="Confort visuel" defaultValue={values.visual_comfort} type="info middle visual " />
          <InfoCard isSelected={currentSelected<=2 || currentSelected==4 || currentSelected==5 || currentSelected==6} updateActive={(state)=>{state?setActive(["temp","window","curtains","dressing","electric_equipement","artificial_light"]):setActive([])}} isActive={isActive} name="thermal_comfort" toggleInfo={() => { onComponentClick("thermal_comfort"); }} min={bounds["thermal_comfort"]["min"]} minUnite="Froid" max={bounds["thermal_comfort"]["max"]} maxUnite="Chaud"  showStepBtn={false}  title="Confort thermique" needPrecision={true} defaultValue={values.thermal_comfort} type="info middle" />

        </Box>
      </Box>



      <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="-3 0 1188 501" id="svg-container">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">

            <g id={KEYS.TEMP_CONSIGNE} className="rect-c" onMouseEnter={(e) => onHoverQuality(["l02", "l01", "l03"], ["temp", "chauffage", "climatisation", "thermal_comfort"])}
              onMouseLeave={(e) => onHoverQuality(["l02", "l01", "l03"], ["temp", "chauffage", "climatisation", "thermal_comfort"], false)}>
              <g className="lines">
                <g id="l01" className={"line"}>
                  <path d="M30.5,120.5l0,60-.38,54.67" fill="none" stroke="#FFD700" />
                  <path d="M30.11,240.42l-3.45-7,3.49,1.77,3.51-1.72Z" fill="#FFD700" stroke="#FFD700" strokeMiterlimit="10" />
                </g>



                <g id="l02" className={"line"}>
                  <path d="M30.5,120.5l0,40H218.12l-.06,72.67" fill="none" stroke="#FFD700" strokeMiterlimit="10" />
                  <path d="M218.06,238.42l-3.49-7,3.49,1.75,3.51-1.75Z" fill="#FFD700" stroke="#FFD700" strokeMiterlimit="10" />
                </g>

                <g id="l03" className={"line"}>
                  <path d="M30.5,120.5l0,40h933l0,73.63" fill="none" stroke="#FFD700" strokeMiterlimit="10" />
                  <path d="M963.46,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#FFD700" stroke="#FFD700" strokeMiterlimit="10" />
                </g>
              </g>
              <rect x="0.5" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#FFD700" className="rect-container" onClick={() => { onComponentClick("temp"); }} />
              <rect x="18" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(58 73)" fontSize="12" fontFamily="ArialMT, Arial" textAnchor="middle" onClick={() => { onComponentClick("temp"); }} >
                {processTextSpans("temp")}
              </text>
              <foreignObject x="36.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("temp", -scales.temp)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="61.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("temp", scales.temp)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {interfaceParams ? <ParameterScale
                min={bounds["temp"]["min"]}
                max={bounds["temp"]["max"]}
                value={targetData.temp}
                pos={[9, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["temp"]["labels"][0], high: interfaceParams["bars"]["temp"]["labels"][1] }
                }}
                asset="temp"
              /> : null}
            </g>

            <g id={KEYS.WINDOW} className="rect-c" onMouseEnter={(e) => onHoverQuality(["l04", "l05", "l06", "l07", "l08"], ["air_quality", "window", "chauffage", "climatisation", "thermal_comfort"])}
              onMouseLeave={(e) => onHoverQuality(["l04", "l05", "l06", "l07", "l08"], ["air_quality", "temp", "window", "chauffage", "climatisation", "thermal_comfort"], false)}>
              <g className="lines">

                <g id="l04" className={"line"}>
                  <path d="M176,80.5H147.5v77c3.9,0,3.9,6,0,6h0v177h87c0-3.9,6-3.9,6,0h182c0-3.9,6-3.9,6,0H591V326.87" fill="none"
                    stroke="#ff8000" strokeMiterlimit="10" />
                  <path d="M591,321.62l3.51,7-3.5-1.74-3.5,1.75Z" fill="#ff8000" stroke="#ff8000" strokeMiterlimit="10" />
                </g>
                {/* <g id="l05" className={"line"}>
                  <path d="M176,80.5H147.5v77c3.9,0,3.9,6,0,6h0v177h87c0-3.9,6-3.9,6,0h182c0-3.9,6-3.9,6,0h323V326.87" fill="none"
                    stroke="#ff8000" strokeMiterlimit="10" />
                  <path d="M751.5,321.62l3.5,7-3.5-1.75-3.5,1.75Z" fill="#ff8000" stroke="#ff8000" strokeMiterlimit="10" />
                </g> */}
                <g id="l06" className={"line"}>
                  <path d="M176,80.5H147.5v77c3.9,0,3.9,6,0,6h0v177h87c0-3.9,6-3.9,6,0h182c0-3.9,6-3.9,6,0H966l0-13.63" fill="none"
                    stroke="#ff8000" strokeMiterlimit="10" />
                  <path d="M966,321.62l3.51,7-3.5-1.74-3.5,1.75Z" fill="#ff8000" stroke="#ff8000" strokeMiterlimit="10" />
                </g>
                <g id="l07" className={"line"}>
                  <path d="M176,80.5H147.5v77c3.9,0,3.9,6,0,6h0v117H128.87" fill="none" stroke="#ff8000" strokeMiterlimit="10" />
                  <path d="M123.62,280.5l7-3.5-1.75,3.5,1.75,3.5Z" fill="#ff8000" stroke="#ff8000" strokeMiterlimit="10" />
                </g>
                <g id="l08" className={"line"}>
                  <path d="M176,80.5H147.5v77c3.9,0,3.9,6,0,6h0v117h23.63" fill="none" stroke="#ff8000" strokeMiterlimit="10" />
                  <path d="M176.38,280.5l-7,3.5,1.75-3.5-1.75-3.5Z" fill="#ff8000" stroke="#ff8000" strokeMiterlimit="10" />
                </g>
              </g>
              <rect x="176" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#ff8000" className="rect-container"
                onClick={() => { onComponentClick("window"); }} />

              {/* <circle cx="296.5" cy="41.5" r="11" fill="#fff" stroke="#ff8000" /><text transform="translate(292.66 45)"
                fontSize="12" fontFamily="ArialMT, Arial" >{targetData.window}</text> */}
              <rect x="193.5" y="54.5" width="85" height="30" fill="none" />

              <text transform="translate(236 73)" textAnchor="middle"
                fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("window"); }}>
                {processTextSpans("window")}
              </text>

              <foreignObject x="211.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("window", -scales.window)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="236.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("window", scales.window)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {interfaceParams ? <ParameterScale
                min={bounds["window"]["min"]}
                max={bounds["window"]["max"]}
                value={targetData.window}
                pos={[187, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["window"]["labels"][0], high: interfaceParams["bars"]["window"]["labels"][1] }
                }}
                asset="window"
              /> : null}
            </g>

            <g id={KEYS.CURTAINS} className="rect-c" onMouseEnter={(e) => onHoverQuality(["l10", "l11", "l09", "l12"], ["curtains", "chauffage", "climatisation", "visual_comfort", "thermal_comfort"])}
              onMouseLeave={(e) => onHoverQuality(["l10", "l11", "l09", "l12"], ["curtains", "chauffage", "climatisation", "visual_comfort", "thermal_comfort"], false)}>
              <g className="lines">

                <g id="l09" className={"line"}>
                  <path d="M397.5,120.5v60h-130v53.63" fill="none" stroke="#0c0" strokeMiterlimit="10" />
                  <path d="M267.5,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#0c0" stroke="#0c0" strokeMiterlimit="10" />
                </g>
                <g id="l10" className={"line"}>
                  <path d="M396.5,120.5v60h361v53.63" fill="none" stroke="#0c0" strokeMiterlimit="10" />
                  <path d="M758,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#0c0" stroke="#0c0" strokeMiterlimit="10" />
                </g>
                <g id="l11" className={"line"}>
                  <path d="M397.5,120.5v60h521l0,53.63" fill="none" stroke="#0c0" strokeMiterlimit="10" />
                  <path d="M918.5,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#0c0" stroke="#0c0" strokeMiterlimit="10" />
                </g>
                <g id="l12" className={"line"}>
                  <path d="M397.5,120.5v60H87.5v53.63" fill="none" stroke="#0c0" strokeMiterlimit="10" />
                  <path d="M87.5,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#0c0" stroke="#0c0" strokeMiterlimit="10" />
                </g>
              </g>
              <rect x="337.5" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#0c0" className="rect-container"
                onClick={() => { onComponentClick("curtains"); }} />

              <rect x="355" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(397.5 73)" fontSize="12"
                fontFamily="ArialMT, Arial" textAnchor="middle" onClick={() => { onComponentClick("curtains"); }}>
                {processTextSpans("curtains")}
              </text>

              <foreignObject x="373" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("curtains", -scales.curtains)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="398" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("curtains", scales.curtains)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {/* <circle cx="457" cy="41.5" r="11" fill="#fff" stroke="#0c0" /> */}
              {/* <text transform="translate(453.66 45)" fontSize="12" fontFamily="ArialMT, Arial" >{targetData.curtains}</text> */}

              {interfaceParams ? <ParameterScale
                min={bounds["curtains"]["min"]}
                max={bounds["curtains"]["max"]}
                value={targetData.curtains}
                pos={[348, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["curtains"]["labels"][0], high: interfaceParams["bars"]["curtains"]["labels"][1] }
                }}
                asset="curtains"
              /> : null}
            </g>


            <g id={KEYS.MECHANICAL_VENT} className="rect-c" onMouseEnter={(e) => onHoverQuality(["l13", "l14"], ["mecanical_ventilation", "air_quality", "electricity"])}
              onMouseLeave={(e) => onHoverQuality(["l13", "l14"], ["mecanical_ventilation", "air_quality", "electricity"], false)}>
              <g className="lines">

                <g id="l13" className={"line"}>
                  <path d="M528.5,80.5H507v77c3.9,0,3.9,6,0,6h0v14c3.9,0,3.9,6,0,6h0v97H491.87" fill="none" stroke="#060"
                    strokeMiterlimit="10" />
                  <path d="M486.62,280.5l7-3.5-1.75,3.5,1.75,3.5Z" fill="#060" stroke="#060" strokeMiterlimit="10" />
                </g>
                <g id="l14" className={"line"}>
                  <path d="M528.5,80.5h-21v77c3.9,0,3.9,6,0,6h0v14c3.9,0,3.9,6,0,6h0v97h17.13" fill="none" stroke="#060"
                    strokeMiterlimit="10" />
                  <path d="M529.88,280.5l-7,3.5,1.75-3.5-1.75-3.5Z" fill="#060" stroke="#060" strokeMiterlimit="10" />
                </g>
                {/* <g id="l15" className={"line"}>
                  <path d="M528.5,80.5h-21v77c3.9,0,3.9,6,0,6h0v14c3.9,0,3.9,6,0,6h0v37H719.57v14.83" fill="none" stroke="#060"
                    strokeMiterlimit="10" />
                  <path d="M719.58,240.58l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#060" stroke="#060" strokeMiterlimit="10" />
                </g> */}
              </g>
              <rect x="528.5" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#060" className="rect-container"
                onClick={() => { onComponentClick("mecanical_ventilation"); }} />

              <rect x="546" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(588.5 73)" fontSize="12" fontFamily="ArialMT, Arial" textAnchor="middle" onClick={() => { onComponentClick("mecanical_ventilation"); }}>
                {processTextSpans("mecanical_ventilation")}
              </text>

              <foreignObject x="564" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("mecanical_ventilation", -scales.mecanical_ventilation)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="589.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("mecanical_ventilation", scales.mecanical_ventilation)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {/* <circle cx="648.5" cy="41.5" r="11" fill="#fff" stroke="#060" /><text transform="translate(644.66 45)"
                fontSize="12" fontFamily="ArialMT, Arial" >{targetData.mecanical_ventilation}</text> */}

              {interfaceParams ? <ParameterScale
                min={bounds["mecanical_ventilation"]["min"]}
                max={bounds["mecanical_ventilation"]["max"]}
                value={targetData.mecanical_ventilation}
                pos={[539, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["mecanical_ventilation"]["labels"][0], high: interfaceParams["bars"]["mecanical_ventilation"]["labels"][1] }
                }}
                asset="mecanical_ventilation"
              /> : null}
            </g>

            {/* <g id={KEYS.PORTABLE_VENT} >
              <g className="lines">

                <g id="l16" className={"line"}>
                  <path d="M751.5,120.5v37c3.9,0,3.9,6,0,6h0v14c3.9,0,3.9,6,0,6h0v50.63" fill="none" stroke="#66b2ff"
                    strokeMiterlimit="10" />
                  <path d="M751.5,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#66b2ff" stroke="#66b2ff" strokeMiterlimit="10" />
                </g>
                <g id="l17" className={"line"}>
                  <path d="M751.5,120.5v20h-334v17c3.9,0,3.9,6,0,6h0v14c3.9,0,3.89,6,0,6h0l0,50.63" fill="none" stroke="#66b2ff"
                    strokeMiterlimit="10" />
                  <path d="M417.46,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#66b2ff" stroke="#66b2ff" strokeMiterlimit="10" />
                </g>
                <g id="l18" className={"line"}>
                  <path d="M751.5,120.5v20h416l0,93.63" fill="none" stroke="#66b2ff" strokeMiterlimit="10" />
                  <path d="M1167.46,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#66b2ff" stroke="#66b2ff" strokeMiterlimit="10" />
                </g>
              </g>
              <rect x="691.5" y="40.5" width="120" height="80" fill="#fff" stroke="#66b2ff" className="rect-container"
                onClick={() => { onComponentClick(KEYS.PORTABLE_VENT); }} />
              <rect x="709" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(700 73)" fontSize="12"
                fontFamily="ArialMT, Arial" >Ventilateur portable
              </text>

              <g className="point-button"
                onMouseEnter={() => changeHoverStatus("sub", "portatif_ventilation", true)}
                onMouseLeave={() => changeHoverStatus("sub", "portatif_ventilation", false)}
                onClick={() => updateData("portatif_ventilation", -1)}
              >
                <rect x="728.5" y="94.5" width="22" height="20" fill={subButtonStatus.portatif_ventilation ? "#1ac" : "#ffe6cc"} stroke="#d79b00" >
                  <title>Min: {DOMAINS["portatif_ventilation"][0]}</title>
                </rect>
                <text
                  transform="translate(737 108)" fontSize="12" fontFamily="ArialMT, Arial" >-</text>
              </g>
              <g className="point-button"
                onMouseEnter={() => changeHoverStatus("add", "portatif_ventilation", true)}
                onMouseLeave={() => changeHoverStatus("add", "portatif_ventilation", false)}
                onClick={() => updateData("portatif_ventilation", 1)}
              >
                <rect x="750.5" y="94.5" width="22" height="20" fill={addButtonStatus.portatif_ventilation ? "#1ac" : "#dae8fc"} stroke="#6c8ebf" >
                  <title>Max: {DOMAINS["portatif_ventilation"][1]}</title></rect>
                <text
                  transform="translate(757.5 108)" fontSize="12" fontFamily="ArialMT, Arial" >+</text>
              </g>
              <circle cx="811.5" cy="41.5" r="11" fill="#fff" stroke="#66b2ff" />
              <text transform="translate(807.66 45)" fontSize="12" fontFamily="ArialMT, Arial" >{targetData.portatif_ventilation}</text>

              {<ParameterScale min={DOMAINS.portatif_ventilation[0]} max={DOMAINS.portatif_ventilation[1]} value={targetData.portatif_ventilation} pos={[698, 45]} />}

            </g> */}

            <g id={KEYS.ARTIFICIAL_LIGHT} transform="translate(-176, 0)" className="rect-c"
              onMouseEnter={(e) => onHoverQuality(["l19", "l20"], ["artificial_light", "visual_comfort", "electricity"])}
              onMouseLeave={(e) => onHoverQuality(["l19", "l20"], ["artificial_light", "visual_comfort", "electricity"], false)}>
              <rect x="872.5" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#9a9b9b" className="rect-container"
                onClick={() => { onComponentClick("artificial_light"); }} />
              <rect x="890" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(932.5 73)" fontSize="12"
                fontFamily="ArialMT, Arial" textAnchor="middle" onClick={() => { onComponentClick("artificial_light"); }}>
                {processTextSpans("artificial_light")}
              </text>
              <g className="lines">
                <g id="l19" className={"line"}>
                  <path d="M962.5,120.5v37c3.9,0,3.9,6,0,6h0v14c3.9,0,3.9,6,0,6h0v50.63" fill="none"
                    stroke="#9a9b9b" strokeMiterlimit="10" />
                  <path d="M962.53,239.38l-3.5-7,3.5,1.75,3.5-1.75Z" fill="#9a9b9b" stroke="#9a9b9b" strokeMiterlimit="10" />
                </g>

                <g id="l20" className={"line"}>
                  <path d="M962.5,120.5v37c3.9,0,3.9,6,0,6h0v14c3.9,0,3.91,6,0,6h0v17h-26c0-3.9-6-3.9-6,0h-245c0-3.9-6-3.9-6,0H603l0,31.71"
                    fill="none" stroke="#9a9b9b" strokeMiterlimit="10" />
                  <path d="M603,237.46l-3.51-7,3.5,1.74,3.5-1.75Z" fill="#9a9b9b" stroke="#9a9b9b" strokeMiterlimit="10" />
                </g>
              </g>

              <foreignObject x="908" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("artificial_light", -scales.artificial_light)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="933" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("artificial_light", scales.artificial_light)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {/* <circle cx="993" cy="41.5" r="11" fill="#fff" stroke="#9a9b9b" /><text transform="translate(988.66 45)"
                fontSize="12" fontFamily="ArialMT, Arial" >{targetData.artificial_light}</text> */}

              {interfaceParams ? <ParameterScale
                min={bounds["artificial_light"]["min"]}
                max={bounds["artificial_light"]["max"]}
                value={targetData.artificial_light}
                pos={[882, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["artificial_light"]["labels"][0], high: interfaceParams["bars"]["artificial_light"]["labels"][1] }
                }}
                asset="artificial_light"
              /> : null}
            </g>

            <g id={KEYS.AL_USAGE} className="rect-c"
              onMouseEnter={(e) => onHoverQuality(["l21"], ["electric_equipement", "electricity"])}
              onMouseLeave={(e) => onHoverQuality(["l21"], ["electric_equipement", "electricity"], false)}>
              <g className="lines">

                <g id="l21" className={"line"}>
                  <path d="M950,40.5V.5h-632.5v280h41.63" fill="none" stroke="blue" strokeMiterlimit="10" />
                  <path d="M950,0.5H1500" fill="none" stroke="blue" strokeMiterlimit="10" />
                  <path d="M364.38,280.5l-7,3.5,1.75-3.5-1.75-3.5Z" fill="blue" stroke="blue" strokeMiterlimit="10" />
                </g>
              </g>

              <g transform="translate(-160, 0)">

                <rect x="1043.5" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="blue" className="rect-container"
                  onClick={() => { onComponentClick("electric_equipement"); }} />
                <rect x="1061" y="54.5" width="85" height="30" fill="none" />
                <text transform="translate(1103.5 73)" fontSize="12" fontFamily="ArialMT, Arial" textAnchor="middle" onClick={() => { onComponentClick("electric_equipement"); }} >
                  {processTextSpans("electric_equipement")}
                </text>

                {/* <circle cx="1163.5" cy="41.5" r="11" fill="#fff" stroke="blue" /><text transform="translate(1159.66 45)"
                fontSize="12" fontFamily="ArialMT, Arial" >{targetData.electric_equipement}</text> */}
                {interfaceParams ? <ParameterScale
                  min={bounds["electric_equipement"]["min"]}
                  max={bounds["electric_equipement"]["max"]}
                  value={targetData.electric_equipement}
                  pos={[1054, 45]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT1,
                    legend: { low: interfaceParams["bars"]["electric_equipement"]["labels"][0], high: interfaceParams["bars"]["electric_equipement"]["labels"][1] }
                  }}
                  asset="electric_equipement"
                /> : null}
              </g>

            </g>


            <g id={KEYS.CLOTHING} transform="translate(-185, 0)" className="rect-c"
              onMouseEnter={(e) => onHoverQuality(["l22"], ["dressing", "thermal_comfort"])}
              onMouseLeave={(e) => onHoverQuality(["l22"], ["dressing", "thermal_comfort"], false)}>
              <g className="lines">

                <g id="l22" className={"line"}>
                  <path d="M1276,120.5l0,160h-72" fill="none" stroke="#66f" strokeMiterlimit="10" />
                  <path d="M1198,280.5l7-3.5-1.75,3.5,1.75,3.5Z" fill="#66f" stroke="#66f" strokeMiterlimit="10" />
                </g>
              </g>
              <rect x="1216" y="40.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#66f" className="rect-container"
                onClick={() => { onComponentClick("dressing"); }} />
              <rect x="1233.5" y="54.5" width="85" height="30" fill="none" />
              <text transform="translate(1276 73)" textAnchor="middle"
                fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("dressing"); }}>
                {processTextSpans("dressing")}
              </text>

              <foreignObject x="1251.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("dressing", -scales.dressing)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>-</Button>
              </foreignObject>
              <foreignObject x="1276.5" y="94.5" width="22" height="20">
                <Button
                  variant="contained"
                  onClick={() => updateData("dressing", scales.dressing)}
                  sx={{ "minWidth": 0, "minHeight": 0, "padding": 0, "lineHeight": 0, "width": "100%", "height": "100%", "verticalAlign": "top" }}>+</Button>
              </foreignObject>

              {/* <circle cx="1336.5" cy="41.5" r="11" fill="#fff" stroke="#66f" />
              <text transform="translate(1332.66 45)"
                fontSize="12" fontFamily="ArialMT, Arial" >{targetData.dressing}
              </text> */}

              {interfaceParams ? <ParameterScale
                min={bounds["dressing"]["min"]}
                max={bounds["dressing"]["max"]}
                value={targetData.dressing}
                pos={[1227, 45]}
                sliderInfo={{
                  gradient: SliderGradient.GRADIENT1,
                  legend: { low: interfaceParams["bars"]["dressing"]["labels"][0], high: interfaceParams["bars"]["dressing"]["labels"][1] }
                }}
                asset="dressing"
              /> : null}
            </g>

            <g className="qualities">

              <g id={KEYS.HEATING}
                onMouseEnter={(e) => onHoverQuality(["l01", "l07", "l12", "l23", "l24"], ["temp", "window", "curtains", "chauffage", "cost", "ges"])}
                onMouseLeave={(e) => onHoverQuality(["l01", "l07", "l12", "l23", "l24"], ["temp", "window", "curtains", "chauffage", "cost", "ges"], false)}>
                <rect x="2.5" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("chauffage"); }} />
                <rect x="20" y="266.5" width="85" height="30" fill="none" />
                <text transform="translate(62.5 285)" fontSize="12" textAnchor="middle"
                  fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("chauffage"); }} >
                  {processTextSpans("chauffage")}
                </text>
                {/* <text transform="translate(46 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.chauffage}
                </text> */}
                {/* {<QualityScale min={getMinHeating()} max={getMaxHeating()} value={values.chauffage} pos={[12.5, 245.5]}
                  thresholdLow={THRESHOLDS.HEATING_LOW} thresholdHigh={THRESHOLDS.HEATING_HIGH} />} */}
                {interfaceParams ? <ParameterScale
                  min={bounds["chauffage"]["min"]}
                  max={bounds["chauffage"]["max"]}
                  value={values.chauffage}
                  pos={[12.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT1,
                    legend: { low: interfaceParams["bars"]["chauffage"]["labels"][0], high: interfaceParams["bars"]["chauffage"]["labels"][1] }
                  }}
                  asset="chauffage"
                /> : null}
              </g>

              <g id={KEYS.AIR_CONDITIONER}
                onMouseEnter={(e) => onHoverQuality(["l02", "l08", "l09", "l25", "l26"], ["temp", "window", "curtains", "climatisation", "cost", "ges"])}
                onMouseLeave={(e) => onHoverQuality(["l02", "l08", "l09", "l25", "l26"], ["temp", "window", "curtains", "climatisation", "cost", "ges"], false)}>
                <rect x="177.5" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("climatisation"); }} />
                <rect x="195" y="266.5" width="85" height="30" fill="none" />
                <text transform="translate(237.5 285)" textAnchor="middle"
                  fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("climatisation"); }} >
                  {processTextSpans("climatisation")}
                </text>
                {/* <text transform="translate(218 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.climatisation}
                </text> */}
                {/* {<QualityScale min={getMinAirConditioning()} max={getMaxAirConditioning()} value={values.climatisation} pos={[187.5, 245.5]}
                  thresholdLow={THRESHOLDS.AIR_CONDITIONING_LOW} thresholdHigh={THRESHOLDS.AIR_CONDITIONING_HIGH} />} */}
                {interfaceParams ? <ParameterScale
                  min={bounds["climatisation"]["min"]}
                  max={bounds["climatisation"]["max"]}
                  value={values.climatisation}
                  pos={[187.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT1,
                    legend: { low: interfaceParams["bars"]["climatisation"]["labels"][0], high: interfaceParams["bars"]["climatisation"]["labels"][1] }
                  }}
                  asset="climatisation"
                /> : null}
              </g>

              <g id={KEYS.ELECTRICITY}
                onMouseEnter={(e) => onHoverQuality(["l21", "l20", "l13", "l27", "l28"], ["artificial_light", "electric_equipement", "mecanical_ventilation", "electricity", "cost", "ges"])}
                onMouseLeave={(e) => onHoverQuality(["l21", "l20", "l13", "l27", "l28"], ["artificial_light", "electric_equipement", "mecanical_ventilation", "electricity", "cost", "ges"], false)}>
                <rect x="365.5" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("electricity"); }} />
                <rect x="383" y="266.5" width="85" height="30" fill="none" />
                <text transform="translate(425.5 285)" textAnchor="middle"
                  fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("electricity"); }} >
                  {processTextSpans("electricity")}
                </text>
                {/* <text transform="translate(410 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.electricity}
                </text> */}
                {/* {<QualityScale min={getMinElectricity()} max={getMaxElectricity()} value={values.electricity} pos={[375.5, 245.5]}
                  thresholdLow={THRESHOLDS.ELECTRICITY_LOW} thresholdHigh={THRESHOLDS.ELECTRICITY_HIGH} />} */}
                {interfaceParams ? <ParameterScale
                  min={bounds["electricity"]["min"]}
                  max={bounds["electricity"]["max"]}
                  value={values.electricity}
                  pos={[375.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT1,
                    legend: { low: interfaceParams["bars"]["electricity"]["labels"][0], high: interfaceParams["bars"]["electricity"]["labels"][1] }
                  }}
                  asset="electricity"
                /> : null}
              </g>

              <g id={KEYS.AIR_QUALITY}
                onMouseEnter={(e) => onHoverQuality(["l14", "l04"], ["window", "mecanical_ventilation", "air_quality"])}
                onMouseLeave={(e) => onHoverQuality(["l14", "l04"], ["window", "mecanical_ventilation", "air_quality"], false)}>
                <rect x="531" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("air_quality"); }} />
                <rect x="548.5" y="265.5" width="85" height="30" fill="none" />
                <text transform="translate(591 284)" textAnchor="middle"
                  fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("air_quality"); }}>
                  {processTextSpans("air_quality")}
                </text>
                {/* <text transform="translate(575 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.airQuality}
                </text> */}
                {/* {<QualityScale min={getMinAirQuality()} max={getMaxAirQuality()} value={values.airQuality} pos={[541.5, 245.5]}
                  thresholdLow={THRESHOLDS.AIR_QUALITY_LOW} thresholdHigh={THRESHOLDS.AIR_QUALITY_HIGH} />} */}
                {interfaceParams ? <ParameterScale
                  min={bounds["air_quality"]["min"]}
                  max={bounds["air_quality"]["max"]}
                  value={values.air_quality}
                  pos={[541.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT1,
                    legend: { low: interfaceParams["bars"]["air_quality"]["labels"][0], high: interfaceParams["bars"]["air_quality"]["labels"][1] }
                  }}
                  asset="air_quality"
                /> : null}
              </g>

              {/* <g id={KEYS.ACOUSITC_COMFORT} >
                <rect x="691.5" y="240.5" width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick(KEYS.ACOUSITC_COMFORT); }} />
                <rect x="713.5" y="264.5" width="85" height="30" fill="none" />
                <text transform="translate(701.98 283)"
                  fontSize="12" fontFamily="ArialMT, Arial" >Confort acoustique
                </text>
                <text transform="translate(740 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.soundConfort}
                </text>
                {<QualityScale min={getMinSoundComfort()} max={getMaxSoundComfort()} value={values.soundConfort} pos={[701.5, 245.5]}
                  thresholdLow={THRESHOLDS.SOUND_COMFORT_LOW} thresholdHigh={THRESHOLDS.SOUND_COMFORT_HIGH} />}
              </g> */}

              <g id={KEYS.VISUAL_COMFORT} transform="translate(-200, 0)"
                onMouseEnter={(e) => onHoverQuality(["l10", "l19"], ["curtains", "artificial_light", "visual_comfort"])}
                onMouseLeave={(e) => onHoverQuality(["l10", "l19"], ["curtains", "artificial_light", "visual_comfort"], false)}>
                <rect x="903.5" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("visual_comfort"); }} />
                <rect x="921" y="266.5" width="85" height="30" fill="none" />
                <text transform="translate(963.5 285)" textAnchor="middle"
                  fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("visual_comfort"); }} >
                  {processTextSpans("visual_comfort")}
                </text>
                {/* <text transform="translate(950 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.visualConfort}
                </text>
                {<QualityScale min={getMinVisualComfort()} max={getMaxVisualComfort()} value={values.visualConfort} pos={[913.5, 245.5]}
                  thresholdLow={THRESHOLDS.VISUAL_COMFORT_LOW} thresholdHigh={THRESHOLDS.VISUAL_COMFORT_HIGH} />} */}

                {interfaceParams ? <ParameterScale
                  min={bounds["visual_comfort"]["min"]}
                  max={bounds["visual_comfort"]["max"]}
                  value={values.visual_comfort}
                  pos={[913.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT2,
                    legend: { low: interfaceParams["bars"]["visual_comfort"]["labels"][0], high: interfaceParams["bars"]["visual_comfort"]["labels"][1] }
                  }}
                  asset="visual_comfort"
                /> : null}
              </g>

              <g id={KEYS.THERMIC_COMFORT} transform="translate(-200, 0)"
                onMouseEnter={(e) => onHoverQuality(["l11", "l03", "l06", "l22"], ["temp", "curtains", "window", "dressing", "thermal_comfort"])}
                onMouseLeave={(e) => onHoverQuality(["l11", "l03", "l06", "l22"], ["temp", "curtains", "window", "dressing", "thermal_comfort"], false)}>
                <rect x="1088.5" y="240.5" rx={"5"} width="120" height="80" fill="#fff" stroke="#000" className="rect-container"
                  onClick={() => { onComponentClick("thermal_comfort"); }} />
                <rect x="1106" y="264.5" width="85" height="30" fill="none" />
                <text transform="translate(1148.5 283)" textAnchor="middle"
                  fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("thermal_comfort"); }}>
                  {processTextSpans("thermal_comfort")}
                </text>
                {/* <text transform="translate(1132 305)"
                  fontSize="14" fontFamily="ArialMT, Arial" >
                  {values.thermalConfort}
                </text>
                {<QualityScale min={getMinThermalComfort()} max={getMaxThermalComfort()} value={values.thermalConfort} pos={[1098.5, 245.5]}
                  thresholdLow={THRESHOLDS.THERMIC_COMFORT_LOW} thresholdHigh={THRESHOLDS.THERMIC_COMFORT_HIGH} />} */}

                {interfaceParams ? <ParameterScale
                  min={bounds["thermal_comfort"]["min"]}
                  max={bounds["thermal_comfort"]["max"]}
                  value={values.thermal_comfort}
                  pos={[1098.5, 245.5]}
                  sliderInfo={{
                    gradient: SliderGradient.GRADIENT2,
                    legend: { low: interfaceParams["bars"]["thermal_comfort"]["labels"][0], high: interfaceParams["bars"]["thermal_comfort"]["labels"][1] }
                  }}
                  asset="thermal_comfort"
                /> : null}
              </g>


              <g id="results">

                <g className={"lines"}
                >
                  <g id="l23" className="line">
                    <path d="M62.5,320.5l0,50h87" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.5,370.5l.3,43.83" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.83,419.38l-3.55-7,3.52,1.72,3.48-1.77Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g id="l24" className="line">
                    <path d="M62.5,320.5l0,50h267" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M327.5,370.5l.44,43.63" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M328,419.38l-3.57-7,3.52,1.71,3.48-1.78Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g id="l25" className="line">
                    <path d="M237.5,320.5v50h-92" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.5,370.5l.3,43.83" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.83,419.38l-3.55-7,3.52,1.72,3.48-1.77Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g id="l26" className="line">
                    <path d="M237.5,320.5v50h92" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M327.5,370.5l.44,43.63" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M328,419.38l-3.57-7,3.52,1.71,3.48-1.78Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g id="l27" className="line">
                    <path d="M425.5,320.5v50h-280" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.5,370.5l.3,43.83" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M147.83,419.38l-3.55-7,3.52,1.72,3.48-1.77Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g id="l28" className="line">
                    <path d="M425.5,320.5v50h-100" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M327.5,370.5l.44,43.63" fill="none" stroke="#000" strokeMiterlimit="10" />
                    <path d="M328,419.38l-3.57-7,3.52,1.71,3.48-1.78Z" stroke="#000" strokeMiterlimit="10" />
                  </g>

                  <g className="line">
                    <path d="M237.5,320.5v50h90" fill="none" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g className="line">
                    <path d="M327.5,370.5l.44,43.63" fill="none" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g className="line">
                    <path d="M328,419.38l-3.57-7,3.52,1.71,3.48-1.78Z" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g className="line">
                    <path d="M425.5,320.5v50h-100" fill="none" stroke="#000" strokeMiterlimit="10" />
                  </g>
                  <g className="line">
                    <path d="M237.5,320.5v50h-90" fill="none" stroke="#000" strokeMiterlimit="10" />
                  </g>
                </g>

                <g id="cost" onMouseEnter={(e) => onHoverQuality(["l23", "l25", "l27"], ["cost", "chauffage", "climatisation", "electricity"])}
                  onMouseLeave={(e) => onHoverQuality(["l23", "l25", "l27"], ["cost", "chauffage", "climatisation", "electricity"], false)}>
                  <rect x="90" y="420.5" rx={"5"} width="120" height="80" fill="#ffffff" stroke="#6c8ebf" className="rect-container"
                    onClick={() => { onComponentClick("cost"); }} />
                  <rect x="108.5" y="430.5" width="85" height="30" fill="none" />
                  <text transform="translate(151 449)" textAnchor="middle"
                    fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("cost"); }} >
                    {processTextSpans("cost")}
                  </text>

                  <text transform="translate(151 481)" textAnchor="middle"
                    fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("cost"); }} >
                    {values.cost.toFixed(2)}
                  </text>
                </g>

                <g id="ges" onMouseEnter={(e) => onHoverQuality(["l24", "l26", "l28"], ["ges", "chauffage", "climatisation", "electricity"])}
                  onMouseLeave={(e) => onHoverQuality(["l24", "l26", "l28"], ["ges", "chauffage", "climatisation", "electricity"], false)}>
                  <rect x="268" y="420.5" rx={"5"} width="120" height="80" fill="#ffffff" stroke="#d79b00" className="rect-container"
                    onClick={() => { onComponentClick("ges"); }} />
                  <rect x="286.5" y="430.5" width="85" height="30" fill="none" />
                  <text transform="translate(329 449)" textAnchor="middle"
                    fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("ges"); }} >
                    {processTextSpans("ges")}
                  </text>
                  <text transform="translate(329 481)" textAnchor="middle"
                    fontSize="12" fontFamily="ArialMT, Arial" onClick={() => { onComponentClick("ges"); }}>
                    {values.ges.toFixed(2)}
                  </text>
                </g>

              </g>
            </g>
          </g>
        </g>
      </svg>
      <Popup
        isShown={showPopup}
        hide={togglePopup}
        headerText={PARAMTER_TITLES.get(selectedParam) || ""}
        modalContent={<DetailsPopup parameter={selectedParam} />}
      />
    </Box>
  );
};


export default Controller;